<template>
  <div class="create-n3-wrapper">
    <!-- Mode 1: Dialog -->
    <v-dialog v-if="!embedded" v-model="dialog" class="dialog-wrapper" width="650px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn depressed color="primary" dark v-bind="attrs" v-on="on">
          <v-icon small class="mr-2">mdi-plus</v-icon>
          Anticipo
        </v-btn>
      </template>
      <v-container fluid>
        <v-card outlined class="p-3" :elevation="$getCardOptions('elevation')">
          <v-card-title class="p-0" v-if="!embedded">
            <v-spacer></v-spacer>
            <v-btn
              class="ml-auto"
              :rounded="$getPrimaryButton('rounded')"
              :color="$getPrimaryButton('color2')"
              @click="dialog = false"
              :disabled="false"
              :loading="loading"
              icon
              large
            >
              <v-icon large>mdi-window-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-title class="pt-0">
            <section-header first="Añadir nuevo" second="registro de Anticipo" />
          </v-card-title>
          <v-card-text>
            <v-tabs v-model="activeTab" grow>
              <v-tab>Anticipo Mes</v-tab>
              <v-tab>Anticipo Fijo Anual</v-tab>
            </v-tabs>
            <v-tabs-items v-model="activeTab">
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-form ref="formMonth" v-model="validMonth">
                      <label class="input-field--label"> Mes: </label>
                      <v-select
                        v-model="formData.month"
                        :items="computedMonthOptions"
                        placeholder="Seleccionar mes"
                        :color="$getColor('vuetifyColor1')"
                        outlined
                        prepend-inner-icon="mdi-calendar"
                        :rules="[v => !!v || 'El mes es requerido']"
                      ></v-select>
                      <label class="input-field--label"> Cantidad (€): </label>
                      <v-text-field
                        v-model="formData.amount"
                        placeholder="Cantidad"
                        type="number"
                        max="700"
                        :color="$getColor('vuetifyColor1')"
                        outlined
                        prepend-inner-icon="paid"
                        :rules="[
                          v => !!v || 'La cantidad es requerida',
                          v => (v && v <= 700) || 'La cantidad máxima es 700'
                        ]"
                      ></v-text-field>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-form ref="formFixed" v-model="validFixed">
                      <label class="input-field--label"> Año: </label>
                      <v-select
                        v-model="fixedFormData.year"
                        :items="yearOptions"
                        placeholder="Seleccionar año"
                        :color="$getColor('vuetifyColor1')"
                        outlined
                        prepend-inner-icon="mdi-calendar"
                        :rules="[v => !!v || 'El año es requerido']"
                      ></v-select>
                      <label class="input-field--label"> Cantidad (€): </label>
                      <v-text-field
                        v-model="fixedFormData.amount"
                        placeholder="Cantidad"
                        type="number"
                        max="700"
                        :color="$getColor('vuetifyColor1')"
                        outlined
                        prepend-inner-icon="paid"
                        :rules="[
                          v => !!v || 'La cantidad es requerida',
                          v => (v && v <= 700) || 'La cantidad máxima es 700'
                        ]"
                      ></v-text-field>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="white--text"
              :rounded="$getPrimaryButton('rounded')"
              :disabled="!isFormValid"
              :outlined="$getPrimaryButton('outlined')"
              :color="$getPrimaryButton('color')"
              large
              @click="submitForm"
              :loading="loading"
            >
              Añadir registro
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-dialog>

    <!-- Mode 2: Embedded -->
    <v-card v-else outlined class="p-3" :elevation="$getCardOptions('elevation')">
      <v-card-title class="pt-0">
        <section-header first="Añadir nuevo" second="registro de Anticipo" />
      </v-card-title>
      <v-card-text>
        <v-tabs v-model="activeTab" grow>
          <v-tab>Anticipo Mes</v-tab>
          <v-tab>Anticipo Fijo Anual</v-tab>
        </v-tabs>
        <v-tabs-items v-model="activeTab">
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-form ref="formMonthEmbedded" v-model="validMonth">
                  <label class="input-field--label"> Mes: </label>
                  <v-select
                    v-model="formData.month"
                    :items="computedMonthOptions"
                    placeholder="Seleccionar mes"
                    :color="$getColor('vuetifyColor1')"
                    outlined
                    prepend-inner-icon="mdi-calendar"
                    :rules="[v => !!v || 'El mes es requerido']"
                  ></v-select>
                  <label class="input-field--label"> Cantidad (€): </label>
                  <v-text-field
                    v-model="formData.amount"
                    placeholder="Cantidad"
                    type="number"
                    max="700"
                    :color="$getColor('vuetifyColor1')"
                    outlined
                    prepend-inner-icon="paid"
                    :rules="[
                      v => !!v || 'La cantidad es requerida',
                      v => (v && v <= 700) || 'La cantidad máxima es 700'
                    ]"
                  ></v-text-field>
                </v-form>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-form ref="formFixedEmbedded" v-model="validFixed">
                  <label class="input-field--label"> Año: </label>
                  <v-select
                    v-model="fixedFormData.year"
                    :items="yearOptions"
                    placeholder="Seleccionar año"
                    :color="$getColor('vuetifyColor1')"
                    outlined
                    prepend-inner-icon="mdi-calendar"
                    :rules="[v => !!v || 'El año es requerido']"
                  ></v-select>
                  <label class="input-field--label"> Cantidad (€): </label>
                  <v-text-field
                    v-model="fixedFormData.amount"
                    placeholder="Cantidad"
                    type="number"
                    max="700"
                    :color="$getColor('vuetifyColor1')"
                    outlined
                    prepend-inner-icon="paid"
                    :rules="[
                      v => !!v || 'La cantidad es requerida',
                      v => (v && v <= 700) || 'La cantidad máxima es 700'
                    ]"
                  ></v-text-field>
                </v-form>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="white--text"
          :rounded="$getPrimaryButton('rounded')"
          :disabled="!isFormValid"
          :outlined="$getPrimaryButton('outlined')"
          :color="$getPrimaryButton('color')"
          large
          @click="submitForm"
          :loading="loading"
        >
          Añadir registro
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="snackbar" :timeout="3000" color="error" top>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false"> Cerrar </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, numeric, maxValue } from 'vuelidate/lib/validators';
import SectionHeader from '@/components/Headers/SectionHeader.vue';
import N3Service from '@/services/n3.service';

export default {
  name: 'create-n3-entry',
  props: {
    workerId: {
      required: false,
    },
    selectedYear: {
      required: true,
    },
    isAdmin: {
      type: Boolean,
      default: true,
    },
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SectionHeader,
  },
  data: () => ({
    mixins: [validationMixin],
    dialog: false,
    loading: false,
    formData: {
      month: null,
      amount: 300,
    },
    snackbar: false,
    snackbarText: '',
    activeTab: 0,
    validMonth: false,
    validFixed: false,
    fixedFormData: {
      year: new Date().getFullYear(),
      amount: 300,
    },
    yearOptions: [
      new Date().getFullYear(),
      new Date().getFullYear() + 1,
    ],
    monthOptions: [
      { text: 'Enero', value: 1 }, { text: 'Febrero', value: 2 }, { text: 'Marzo', value: 3 },
      { text: 'Abril', value: 4 }, { text: 'Mayo', value: 5 }, { text: 'Junio', value: 6 },
      { text: 'Julio', value: 7 }, { text: 'Agosto', value: 8 }, { text: 'Septiembre', value: 9 },
      { text: 'Octubre', value: 10 }, { text: 'Noviembre', value: 11 }, { text: 'Diciembre', value: 12 },
    ],
  }),
  validations() {
    return {
      formData: {
        month: { required },
        amount: { required, numeric, maxValue: maxValue(700) },
      },
    };
  },
  computed: {
    isFormValid() {
      return this.activeTab === 0 ? this.validMonth : this.validFixed;
    },
    computedMonthOptions() {
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth() + 1; // 1-12
      const currentDay = now.getDate();
      const selectedYear = Number(this.selectedYear);

      return this.monthOptions.map((option) => {
        let disabled = false;
        if (selectedYear < currentYear) {
          disabled = true;
        } else if (selectedYear === currentYear) {
          if (option.value < currentMonth) {
            disabled = true;
          } else if (option.value === currentMonth && currentDay > 9) {
            disabled = true;
          }
        }
        return { ...option, disabled };
      });
    },
    availableN3() {
      console.log('this.$store.state', this.$store.state);
      return this.$store.state.availableN3 === 'true';
    },
  },
  methods: {
    newRegister() {
      this.loading = true;
      if (this.isAdmin) {
        N3Service.addAdminN3Entry(this.workerId, this.selectedYear, this.formData.month, this.formData.amount)
          .then(() => {
            this.$emit('entryAdded');
            this.dialog = false;
            this.formData.month = null;
            this.formData.amount = 300;
          })
          .catch((error) => {
            console.error(error);
            if (error.response && error.response.status === 404) {
              this.snackbarText = 'No se ha podido crear el registro.';
              this.snackbar = true;
            }
          })
          .finally(() => { this.loading = false; });
      } else {
        N3Service.addWorkerN3Entry(this.selectedYear, this.formData.month, this.formData.amount)
          .then(() => {
            this.$emit('entryAdded');
            this.dialog = false;
            this.formData.month = null;
            this.formData.amount = 300;
          })
          .catch((error) => {
            console.error(error);
            if (error.response && error.response.status === 404) {
              this.snackbarText = 'No se ha podido crear el registro.';
              this.snackbar = true;
            }
          })
          .finally(() => { this.loading = false; });
      }
    },
    submitForm() {
      let form;
      if (this.activeTab === 0) {
        form = this.embedded ? this.$refs.formMonthEmbedded : this.$refs.formMonth;
      } else {
        form = this.embedded ? this.$refs.formFixedEmbedded : this.$refs.formFixed;
      }

      if (form.validate()) {
        if (this.activeTab === 0) {
          this.newRegister();
        } else {
          this.addFixedEntry();
        }
      }
    },
    addFixedEntry() {
      this.loading = true;
      if (this.isAdmin) {
        N3Service.addAdminFixedN3EntriesForYear(this.workerId, this.fixedFormData.year, this.fixedFormData.amount)
          .then(() => {
            this.$emit('entryAdded');
            this.dialog = false;
            this.fixedFormData.year = new Date().getFullYear();
            this.fixedFormData.amount = 300;
          })
          .catch((error) => {
            console.error(error);
            if (error.response && error.response.status === 404) {
              this.snackbarText = 'No se ha podido crear el registro fijo.';
              this.snackbar = true;
            }
          })
          .finally(() => { this.loading = false; });
      } else {
        N3Service.addFixedN3EntriesForYear(this.fixedFormData.year, this.fixedFormData.amount)
          .then(() => {
            this.$emit('entryAdded');
            this.dialog = false;
            this.fixedFormData.year = new Date().getFullYear();
            this.fixedFormData.amount = 300;
          })
          .catch((error) => {
            console.error(error);
            if (error.response && error.response.status === 404) {
              this.snackbarText = 'No se ha podido crear el registro fijo.';
              this.snackbar = true;
            }
          })
          .finally(() => { this.loading = false; });
      }
    },
  },
};
</script>
